import React, {FC} from 'react';
import styled from 'styled-components';

import {CellsContext} from '../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ViewerPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {ConversationModel} from '../../../models/api/conversationModel';
import {InboxesParameters} from '../../../store/panels/inboxes/parameters/inboxesParameters';
import {ConversationSubjectWrapper} from '../../inboxes/viewer/conversation/header/conversationSubjectWrapper';
import {ConversationTopbarInviteContainer} from '../../inboxes/viewer/conversation/topbar/conversationTopbarInviteContainer';
import {VisitorConversationsHeaderSubscribe} from './visitorConversationsHeaderSubscribe';

/*
 * Props.
 */

export interface VisitorConversationsHeaderProps {
  panelId: ViewerPanelId;
  cellsContext: CellsContext;
  conversation: ConversationModel | undefined;
  inboxesParameters: InboxesParameters;
  isVisitorSubscribedAll: boolean;
  resubscribeAllVisitorNotifications: () => void;
}

/*
 * Style.
 */

const StyledHeaderDiv = styled.div`
  grid-area: header;
  background-color: ${(p) => p.theme.greys.shade20};
`;

const StyledContentDiv = styled.div`
  display: flex;
  padding: 6px 8px 6px 16px;
`;

const StyledLeftDiv = styled.div`
  flex: 1;
  min-width: 0;
  position: relative;
`;

const StyledContentItemsDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 10px 0 8px;
`;

const StyledSubscribeDiv = styled.div`
  padding-left: 12px;
`;

/*
 * Component.
 */

export const VisitorConversationsHeader: FC<VisitorConversationsHeaderProps> = (props) => {
  const {cellsContext, conversation, panelId} = props;

  if (!conversation) {
    return null;
  }

  return (
    <StyledHeaderDiv>
      <StyledContentDiv>
        <StyledLeftDiv>
          <ConversationSubjectWrapper
            cellsContext={cellsContext}
            conversation={conversation}
            panelId={panelId}
            isUserVisitor
          />
        </StyledLeftDiv>
        <StyledContentItemsDiv>
          <ConversationTopbarInviteContainer cellsContext={cellsContext} conversation={conversation} />
          {maybeRenderVisitorConversationSubscribe(props)}
        </StyledContentItemsDiv>
      </StyledContentDiv>
    </StyledHeaderDiv>
  );
};

function maybeRenderVisitorConversationSubscribe(props: VisitorConversationsHeaderProps) {
  const {cellsContext, conversation, isVisitorSubscribedAll, resubscribeAllVisitorNotifications} = props;

  if (!conversation) {
    return null;
  }

  return (
    <StyledSubscribeDiv>
      <VisitorConversationsHeaderSubscribe
        cellsContext={cellsContext}
        conversation={conversation}
        isVisitorSubscribedAll={isVisitorSubscribedAll}
        resubscribeAllVisitorNotifications={resubscribeAllVisitorNotifications}
      />
    </StyledSubscribeDiv>
  );
}
